/* Built In Imports */
/* External Imports */
import { Box, Button, Flex, Image, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
/* Styles */
import OwnSt from '@moms/styleData/OwnSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const LeftBox = ({ region, lang, sectionContent }) => {
  // console.log(sectionContent, 'own');
  const title = sectionContent[0]?.text;
  const desc = sectionContent[1]?.text;
  const buttonText = sectionContent[2]?.buttonText;
  const buttonLink = sectionContent[2]?.linkUrl;
  const cards = sectionContent[3]?.cards;
  const mobileImageData = sectionContent[4]?.mobileImage;
  return (
    <Flex
      flexDir={{ base: 'column' }}
      color={'#FFFFFF'}
      // ml={{ md: '5%', lg: '10%', xl: '18%', '2xl': '30%' }}
      fontFamily="Geist"
      fontWeight={500}
      px="1rem"
      pb="2rem"
    >
      <Text
        {...OwnSt[lang].title}
        // fontSize={{ base: '26px', md: '2rem' }}
        // lineHeight={{ base: '31.2px', md: '37.76px' }}
      >
        {title}
      </Text>
      <Text
        background="linear-gradient(270deg, #EC2224 0%, #636EFF 100%)"
        sx={{ textFillColor: 'transparent', backgroundClip: 'text' }}
        {...OwnSt[lang].desc}
      >
        {desc}
      </Text>
      {/* box for button  and icons */}
      <Box
        display={'flex'}
        alignItems={'center'}
        gap={{ base: '1.2rem', md: '1.5rem', lg: '3rem', '2xl': '2rem' }}
        mt={{ base: '1.8rem', md: '2rem' }}
      >
        <Button
          height="auto"
          display={{ base: 'flex' }}
          as={Link}
          href={buttonLink || '#'}
          maxWidth={{ base: '165px', md: '400px' }}
          fontWeight={700}
          borderWidth={'1px'}
          border={'none'}
          fontSize={{ base: '14px', md: '1rem' }}
          lineHeight={{ base: '18.2px', md: '20.8px' }}
          width={{ base: 'auto', md: '100%' }}
          borderRadius={'55px'}
          fontFamily="Geist"
          color={'#EC1C2D'}
          bgColor={'#FFFFFF'}
          _hover={{ bgColor: '#DBDBDB', textDecor: 'none', color: '#EC1C2D' }}
          _active={{ bgColor: '#DBDBDB', textDecor: 'none', color: '#EC1C2D' }}
          _focus={{ bgColor: '#DBDBDB', textDecor: 'none', color: '#EC1C2D' }}
          whiteSpace="normal"
          textDecor="none"
          textTransform="uppercase"
          {...OwnSt[lang].button}
        >
          {buttonText}
        </Button>

        <Flex gap={{ base: '1.5rem' }}>
          {cards?.map((card, index) => (
            <Link
              display="block"
              height={{ md: '24px' }}
              width={index === 0 ? '20px' : '22.17px'} // Adjust width for different images
              href={card.buttonLink}
              target="_blank"
            >
              <Image
                key={index}
                src={card?.thumbnails?.[0]?.url} // Use the thumbnail URL from the card
                alt={card?.thumbnails?.[0]?.alt}
              />
            </Link>
          ))}
        </Flex>
      </Box>
      <Box
        width={'100%'}
        mt={'3rem'}
        height={{ base: '161px' }}
        display={{ base: 'block', md: 'none' }}
        right={{ md: '2%', lg: '8%', xl: '12%', '2xl': '20%' }}
      >
        <Image
          width={'100%'}
          objectFit="contain"
          objectPosition={{ bases: 'bottom', md: 'top left' }}
          height={'100%'}
          src={mobileImageData?.url}
          alt={mobileImageData?.alt}
        />
      </Box>
    </Flex>
  );
};

const RightBox = ({ region, lang, sectionContent }) => {
  const imageData = sectionContent[4]?.image;
  const mobileImageData = sectionContent[4]?.mobileImage;
  return (
    <Box
      width={{ md: '435px', lg: '535px' }}
      height={{ md: '250px' }}
      display={{ base: 'none', md: 'block' }}
      // pos={{ md: 'absolute' }}
      right={{ md: '2%', lg: '4%', xl: '12%', '2xl': '20%' }}
      alignSelf="flex-end"
    >
      <Image
        width={'100%'}
        height={'100%'}
        objectFit="contain"
        objectPosition="bottom"
        // Use mobile image for base and image for md and larger
        src={imageData?.url || mobileImageData?.url}
        alt={imageData?.alt || mobileImageData?.alt}
      />
    </Box>
  );
};

const OwnYourDay = ({ region, lang, sectionContent }) => {
  return (
    <Box
      minH={{ md: '270px' }}
      pos={'relative'}
      overflow={'hidden'}
      pt={{ base: '5rem', md: '5rem' }}
    >
      <Flex
        flexDir={{ md: 'row-reverse' }}
        justifyContent={{ md: 'center' }}
        gap={{ md: '1rem', lg: '4rem' }}
        overflowY={'hidden'}
      >
        {/* Right  box  for image */}
        <RightBox region={region} lang={lang} sectionContent={sectionContent} />
        {/* left box */}
        <LeftBox region={region} lang={lang} sectionContent={sectionContent} />
      </Flex>
    </Box>
  );
};

export default OwnYourDay;
